<template>
    <div id="testimonials">
        <!--=====================================-->
        <!--=        Testimonials Area Start     =-->
        <!--=====================================-->
        <section class="section section-padding mb--20">
            <div class="container">
                <div class="section-heading heading-left mb-0">
                    <span class="subtitle primary">Testimonios</span>
                    <div class="row">
                        <div class="col-lg-7">
                            <h2 class="font-weight-100">
                                Lo que dicen <br> de <span class="bold">nosotros</span>.
                            </h2>
                        </div>
                    </div>
                </div>

                <!-- TESTIMONIOS WEB  -->
                <div class="row web-mobile">
                    <div v-for="(item, index) in testimonials" class="col-lg-4" data-sal="slide-up" data-sal-duration="1000"
                        data-sal-delay="100">
                        <div class="testimonial-grid">
                            <div class="author-info">
                                <div class="thumb">
                                    <img :src="`${avatar_base}${index + 1}.png`" alt="Google Review">
                                </div>
                                <div class="content">
                                    <template v-if="item.urlName == null">
                                        <span class="name bold h6">
                                            {{ item.name }}
                                        </span>
                                    </template>
                                    <template v-else>
                                        <span class="name bold h6 text-decoration-underli ne">
                                            <a @click.stop="redirectThirdSite(`${item.urlName}`)">{{ item.name }}</a>
                                        </span>
                                    </template>
                                    <span class="designation">{{ item.since }}</span>
                                </div>
                            </div>
                            <p>
                                “{{ item.opinion }}“
                            </p>
                        </div>
                    </div>
                </div>

                <!-- TESTIMONIOS MOBILE -->
                <section class="section pt-0 related-blog-area mobile-testimonies">
                    <div class="container">
                        <slick :options="slickOptionsTestimonies">
                            <div v-for="(item, index) in testimonials" class="col-lg-4" data-sal="slide-up"
                                data-sal-duration="1000" data-sal-delay="100">
                                <div class="testimonial-grid">
                                    <div class="author-info">
                                        <div class="thumb">
                                            <img :src="`${avatar_base}${index + 1}.png`" alt="Google Review">
                                        </div>
                                        <div class="content">
                                            <template v-if="item.urlName == null">
                                                <span class="name bold h6">
                                                    {{ item.name }}
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span class="name bold h6 text-decoration-underli ne">
                                                    <a @click.stop="redirectThirdSite(`${item.urlName}`)">{{ item.name
                                                    }}</a>
                                                </span>
                                            </template>
                                            <span class="designation">{{ item.since }}</span>
                                        </div>
                                    </div>
                                    <p>
                                        “{{ item.opinion }}“
                                    </p>
                                </div>
                            </div>
                        </slick>
                    </div>
                </section>
            </div>
        </section>

        <!--=====================================-->
        <!--=       Recent Post Area Start      =-->
        <!--=====================================-->
        <section class="section pt-0 related-blog-area">
            <div class="container">
                <slick :options="slickOptions">
                    <div v-for="(paper, index) in papers" class="slick-slide">
                        <div class="blog-list">
                            <div class="post-thumbnail">
                                <a @click.stop="redirectThirdSite(paper.link)" target="_blank"><img
                                        :src="`${paper_base}${paper.imagePath}.png`" alt="Blog Post"></a>
                            </div>
                            <div class="post-content">
                                <h5 class="title"><a @click.stop="redirectThirdSite(paper.link)">{{ paper.title }}</a></h5>
                                <!-- <p>{{ paper.resume }}</p> -->
                                <a @click.stop="redirectThirdSite(paper.link)" target="_blank" class="more-btn">Conoce más<i
                                        class="far fa-angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                </slick>
            </div>
        </section>
    </div>
</template>

<script>
import Slick from 'vue-slick';
const papers = [
    {
        title: "Un nuevo crowdfunding facilita la compra de paneles solares en México",
        resume: "RedGirasol es la creación de dos regiomontanos de 25 años que buscan democratizar el acceso a las energías verdes en casa.",
        link: "https://expansion.mx/emprendedores/2017/04/04/un-nuevo-crowdfunding-facilita-la-compra-de-paneles-solares-en-mexico",
        imagePath: "cnn"
    },
    {
        title: "RedGirasol fusiona el fondeo colectivo con energía solar para hogares y comercios",
        resume: "RedGirasol conecta a personas y empresas que quieran instalar paneles con aquellas que busquen invertir en proyectos verdes.",
        link: "https://www.forbes.com.mx/redgirasol-fusiona-el-fondeo-colectivo-con-energia-solar-para-hogares-y-comercios/",
        imagePath: "forbes"
    },
    {
        title: "Silicón mexicano",
        resume: "El éxito de Silicon Valley ha sido la creación de un ecosistema que promueve a los emprendedores de ideas, incluso descabelladas.",
        link: "https://www.dineroenimagen.com/2017-03-15/84621",
        imagePath: "dinero"
    },
    {
        title: "Esta plataforma ayuda a fondear proyectos de energía solar",
        resume: "Se trata de una plataforma de financiamiento colectivo que conecta a acreedores, inversionistas e instaladores de paneles solares, con la finalidad de impulsar el uso de energías limpias.",
        link: "https://www.elfinanciero.com.mx/empresas/esta-plataforma-ayuda-a-fondear-proyectos-de-energia-solar/",
        imagePath: "el-financiero"
    },
    {
        title: "Utilizan esquema fintech para financiar proyectos sustentables",
        resume: "Red Girasol es pionera en crowdfunding en AL enfocada a proyectos de energía solar.",
        link: "https://www.eleconomista.com.mx/sectorfinanciero/Utilizan-esquema-fintech-para-financiar-proyectos-sustentables-20170801-0018.html",
        imagePath: "el-economista"
    },
];

const testimonials = [
    {
        name: "@luischollet",
        urlName: "https://www.instagram.com/reel/CpDePdHjKPT/?igshid=MTc4MmM1YmI2Ng==",
        since: "Inversionista desde 2018",
        opinion: "Desde la perspectiva de alguien que busca un propósito en todo lo que hace, incluso invertir al dinero, RedGirasol es el camino."
    },
    {
        name: "Daniel Brown",
        urlName: null,
        since: "Inversionista desde 2017",
        opinion: "Mi esposa y yo estamos por llegar a 200 proyectos en los que hemos invertido desde que nació RedGirasol."
    },
    {
        name: "Israel Escamilla",
        urlName: null,
        since: "Asesor de Inversión Certificado CNBV: 30056",
        opinion: "En RedGirasol encontré una alternativa de inversión confiable para mis clientes con rendimientos estables y competitivos."
    },
];
export default {
    name: "Testimonials",
    components: {
        Slick
    },
    data() {
        return {
            papers: papers,
            testimonials: testimonials,
            avatar_base: "https://cdn.redgirasol.com/nuevo_portal/fotografias/avatar-",
            paper_base: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-",
            slickOptions: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 2,
                responsive: [
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            },
            slickOptionsTestimonies: {
                infinite: true,
                autoplay: true,
                arrows: false,
                dots: true,
                slidesToShow: 1,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            }
        }
    },
    async mounted() {

    }
}

</script>

<style scoped>
#testimonials {
    position: relative;
    top: -10rem;
    z-index: 0;
}

@media only screen and (max-width: 991px) {
    #testimonials {
        position: inherit;
    }
}

.author-info {
    margin-bottom: 1rem;
}

.testimonial-grid p {
    line-height: 1.5;
}

.blog-list .post-thumbnail a img {
    width: 100% !important;
}

.blog-list .post-thumbnail {
    width: 20rem;
}

.blog-list .post-content .title a {
    display: block;
}

.mobile-testimonies {
    display: none;
}

.web-mobile {
    display: flex;
}

@media only screen and (max-width: 575px) {
    .mobile-testimonies {
        display: block;
    }
    .web-mobile {
        display: none;
    }
}
</style>